import React from 'react';
import dayjs from 'dayjs';
import moment from 'moment';
import { Col, Radio, Row, Select } from 'antd';
import { defaultEmptyString } from '../../../functions';
import { color } from '../../../resources';

export const countEmptyFields = (obj) => {
  const count = Object.keys(obj).reduce((count, key) => {
    if (obj[key] === '' || (Array.isArray(obj[key]) && obj[key].length === 0)) {
      return count + 1;
    }
    return count;
  }, 0);
  return count - 1;
};

export const mapDetails = (details) => {
  const data = [
    {
      title: 'รุ่น',
      description: details.name,
    },
    {
      title: 'ความจุ',
      description: details.spec,
    },
    {
      title: 'Model เครื่อง',
      description: details.region,
    },
    {
      title: 'ประกัน',
      description: details.warranty,
    },
    {
      title: 'สภาพตัวเครื่อง',
      description: details.frameCondition,
    },
    {
      title: 'สภาพหน้าจอ',
      description: details.displayCondition,
    },
    {
      title: 'สภาพฝาหลัง',
      description: details.backCoverCondition,
    },
    {
      title: 'สภาพกล้องหลัง',
      description: details.backCameraCondition,
    },
    {
      title: 'สุขภาพแบต',
      description: details.battery,
    },
    {
      title: 'อุปกรณ์เสริมที่มี',
      description: details.accessory,
    },
    {
      title: 'สภาพการใช้งาน',
      description: details.usedCondition,
    },
  ];

  return data.map((eData) => {
    return {
      ...eData,
      description: defaultEmptyString(eData.description),
    };
  });
};

export const mapBookingDetailsOffSite = (details) => {
  const data = [
    {
      title: 'ประเภทการนัดหมาย',
      description: details.bookingType,
    },
    {
      title: 'ที่อยู่',
      description: `${details?.street} ${details?.subdistrict} ${details?.district} ${details?.province} ${details?.postalCode}`,
      color: color.theme,
    },
    {
      title: 'พิกัดบนแผนที่',
      description: `${details?.currentPosition?.lat} , ${details?.currentPosition?.lng}`,
      color: color.theme,
    },
    {
      title: 'วันที่นัดหมาย',
      description: details.bookingDate,
      color: color.theme,
    },
    {
      title: 'เวลานัดหมาย',
      description: details.bookingTime,
      color: color.theme,
    },
    {
      title: 'ชื่อ-นามสกุลผู้ขาย',
      description: `${details.firstName} ${details.lastName}`,
    },
    {
      title: 'เบอร์ติดต่อ',
      description: details.tel,
    },
    {
      title: 'ไลน์ไอดี',
      description: details.lineId,
    },
    {
      title: 'อีเมล',
      description: details.email,
    },
  ];

  return data.map((eData) => {
    return {
      ...eData,
      description: defaultEmptyString(eData.description),
    };
  });
};

export const mapBookingDetailsBranch = (details) => {
  const data = [
    {
      title: 'ประเภทการนัดหมาย',
      description: details.bookingType,
    },
    {
      title: 'สาขา',
      description: details.branch,
      color: color.theme,
    },
    {
      title: 'วันที่นัดหมาย',
      description: details.bookingDate,
      color: color.theme,
    },
    {
      title: 'เวลานัดหมาย',
      description: details.bookingTime,
      color: color.theme,
    },
    {
      title: 'ชื่อ-นามสกุลผู้ขาย',
      description: `${details.firstName} ${details.lastName}`,
    },
    {
      title: 'เบอร์ติดต่อ',
      description: details.tel,
    },
    {
      title: 'ไลน์ไอดี',
      description: details.lineId,
    },
    {
      title: 'อีเมล',
      description: details.email,
    },
  ];

  return data.map((eData) => {
    return {
      ...eData,
      description: defaultEmptyString(eData.description),
    };
  });
};

// export const removeDuplicates = (arr) => {
//   const uniqueArray = [];
//   const values = new Set();

//   arr.forEach(item => {
//     if (!values.has(item.value)) {
//       values.add(item.value);
//       uniqueArray.push(item);
//     }
//   });

//   return uniqueArray;
// }

export const removeDuplicates = (array = [], primaryKey = 'value') => {
  const seen = new Set();
  return array.reduce((result, item) => {
    const keyValue = item[primaryKey];
    if (!seen.has(keyValue)) {
      seen.add(keyValue);
      return [...result, { ...item }];
    }
    return result;
  }, []);
};

const getThaiMonth = (monthNumber) => {
  const thaiMonths = {
    0: 'มกราคม',
    1: 'กุมภาพันธ์',
    2: 'มีนาคม',
    3: 'เมษายน',
    4: 'พฤษภาคม',
    5: 'มิถุนายน',
    6: 'กรกฎาคม',
    7: 'สิงหาคม',
    8: 'กันยายน',
    9: 'ตุลาคม',
    10: 'พฤศจิกายน',
    11: 'ธันวาคม',
  };

  return thaiMonths[monthNumber];
};

export const thaiDate = (dateString) => {
  // แปลงวันที่ให้เป็น Moment.js object
  const date = moment(dateString, 'YYYY-MM-DD');

  // แปลงเดือนให้เป็นภาษาไทย
  const thaiMonth = getThaiMonth(date.month());

  // สร้างข้อความวันที่ในภาษาไทย
  const thaiDateString = `${date.format('DD')} ${thaiMonth} ${date.format('YYYY')}`;

  return thaiDateString;
};

export const headerRender = ({ value, type, onChange, onTypeChange }) => {
  /* dropdown เดือน/ปี โชว์เฉพาะที่อยู่ในกรอบ 7 วัน — กรอบสั้นขนาดนี้จะคร่อมได้มากสุด 2 เดือน/2 ปี */
  const { minBookingDate, maxBookingDate } = getBookingWindow();
  const minDate = minBookingDate.startOf('day');
  const maxDate = maxBookingDate.startOf('day');

  const current = value || dayjs();
  const year = current.year();
  const month = current.month();

  const firstMonth = year === minDate.year() ? minDate.month() : 0;
  const lastMonth = year === maxDate.year() ? maxDate.month() : 11;
  const monthOptions = [];
  for (let i = firstMonth; i <= lastMonth; i++) {
    monthOptions.push(
      <Select.Option key={i} value={i} className="month-item">
        {getThaiMonth(i)}
      </Select.Option>,
    );
  }

  const options = [];
  for (let i = minDate.year(); i <= maxDate.year(); i += 1) {
    options.push(
      <Select.Option key={i} value={i} className="year-item">
        {i}
      </Select.Option>,
    );
  }
  return (
    <div
      style={{
        padding: 8,
      }}
    >
      <Row gutter={8}>
        <Col>
          <Radio.Group size="small" onChange={(e) => onTypeChange(e.target.value)} value={type}>
            <Radio.Button value="month">เดือน</Radio.Button>
            <Radio.Button value="year">ปี</Radio.Button>
          </Radio.Group>
        </Col>
        <Col>
          <Select
            size="small"
            dropdownMatchSelectWidth={false}
            className="my-year-select"
            value={year}
            onChange={(newYear) => {
              const now = value.clone().year(newYear);
              onChange(now);
            }}
          >
            {options}
          </Select>
        </Col>
        <Col>
          <Select
            size="small"
            dropdownMatchSelectWidth={false}
            value={month}
            onChange={(newMonth) => {
              const now = value.clone().month(newMonth);
              onChange(now);
            }}
          >
            {monthOptions}
          </Select>
        </Col>
      </Row>
    </div>
  );
};

export const disabledHours = (type) => {
  const hours = [];
  let workingHoursStart = 11;
  let workingHoursEnd = 20;
  if (type === 'BOOK-0002') {
    workingHoursStart = 10;
    workingHoursEnd = 18;
  }

  for (let i = 0; i < 24; i++) {
    if (i < workingHoursStart || i >= workingHoursEnd) {
      hours.push(i);
    }
  }
  // for (let i = 0; i < from; i++) {
  //   hours.push(i);
  // }

  // for (let i = to + 1; i < 24; i++) {
  //   hours.push(i);
  // }

  return hours;
};

export const disabledMinutes = (selectedHour, type) => {
  let workingHoursStart = 11;
  let workingHoursEnd = 20;
  if (type === 'BOOK-0002') {
    workingHoursStart = 10;
    workingHoursEnd = 18;
  }

  if (selectedHour === workingHoursStart) {
    // Disable นาทีช่วงเวลานอก 11:00 - 11:59
    return Array.from({ length: 60 }, (_, i) => (i < 0 ? i : null)).filter(Boolean);
  } else if (selectedHour === workingHoursEnd - 1) {
    // Disable นาทีช่วงเวลานอก 17:00 - 17:59
    return Array.from({ length: 60 }, (_, i) => (i >= 60 ? i : null)).filter(Boolean);
  }

  // if (selectedHour === 10) {
  //   return [...Array(60).keys()].slice(0, 30); // ปิดนาทีในช่วง 09:00 - 09:59
  // }
  // if (selectedHour === to) {
  //   return [...Array(60).keys()].slice(1, 60); // ปิดนาทีในช่วง 18:01 - 18:59
  // }
  return [];
};

/* กรอบวันที่เปิดให้จอง: 7 วันโดยนับวันนี้เป็นวันแรก (วันนี้ + อีก 6 วัน) */
export const getBookingWindow = () => ({
  minBookingDate: dayjs().startOf('day'),
  maxBookingDate: dayjs().add(6, 'day').endOf('day'),
});

export const disabledDate = (current, type) => {
  const { minBookingDate: today, maxBookingDate } = getBookingWindow();

  /* Disable: ก่อนวันนี้ | เกินวันสุดท้ายที่เปิดจอง */
  if (type === 'BOOK-0001') {
    return (
      current &&
      (current.isBefore(today) || // Disable วันก่อนหน้าวันนี้
        current.isAfter(maxBookingDate)) // Disable เกิน 7 วันนับจากวันนี้
    );
  }

  /* Disable: ก่อนวันนี้ | วันอาทิตย์ | เกินวันสุดท้ายที่เปิดจอง */
  if (type === 'BOOK-0002') {
    return (
      current &&
      (current.isBefore(today) || // Disable today and past dates
        current.day() === 0 || // Disable Sundays
        current.isAfter(maxBookingDate))
    );
  }
};

/**
 * บีบวันที่ให้อยู่ในกรอบ 7 วันเสมอ
 * จำเป็นเพราะ dropdown เลือกเดือน/ปีบน header ของ Calendar ยิง onSelect เหมือนกับการคลิกวันที่
 * ถ้าไม่บีบ ผู้ใช้จะเลือกวันนอกกรอบได้ (เช่น ตุลาคม 2028) ทั้งที่ช่องวันที่ถูก disable ไว้แล้ว
 */
export const clampBookingDate = (date, type) => {
  const { minBookingDate, maxBookingDate } = getBookingWindow();
  const start = minBookingDate.startOf('day');
  const end = maxBookingDate.startOf('day');

  let next = date.startOf('day');
  if (next.isBefore(start)) next = start;
  if (next.isAfter(end)) next = end;

  /* เผื่อวันที่ที่บีบมาแล้วยังถูกปิดอยู่ (เช่นวันอาทิตย์ของนัดเข้าสาขา) — ถอยหลังก่อน ถ้าไม่เจอค่อยเดินหน้า */
  for (let d = next; !d.isBefore(start); d = d.subtract(1, 'day')) {
    if (!disabledDate(d, type)) return d;
  }
  for (let d = next; !d.isAfter(end); d = d.add(1, 'day')) {
    if (!disabledDate(d, type)) return d;
  }
  return next;
};

// ฟังก์ชันเพื่อสร้างช่วงเวลาที่ต้องการ
export const generateTimes = (type) => {
  let startHour = 11;
  let endHour = 20;
  if (type === 'BOOK-0002') {
    startHour = 10;
    endHour = 18;
  }
  const times = [];
  for (let hour = startHour; hour <= endHour; hour++) {
    for (let minute = 0; minute < 60; minute += 30) {
      // กำหนดช่วงเวลาให้เลือก เช่น ทุก 30 นาที
      times.push(moment().hours(hour).minutes(minute).seconds(0));
    }
  }
  return times;
};
